/* ==========================================================================
   UiPanel > Config
   ========================================================================== */

const config = {
    component: 'UiPanel',
    init: true,
    autoDom: true,
    autoStore: true,
    triggers: [],
    onClick: () => {},
    onOpen: () => {},
    onClose: () => {},
    hasClose: true,
    type: 'panel-type',
    menuOpen: 'data-uipanel-menu',
    panelClose: 'data-uipanel-close',
    cssVisible: 'is-visible'
};

module.exports = config;
